import { routing } from '@/i18n/routing'
import { getCreateDomain, getCurrentDomain, getViveAvatarDomain } from '@/lib/configs'
import { applyUnderline } from '@/lib/utils'
import { getUserLocale } from '@/server/services/locales'
import { API_ENPOINT_LOGIN, API_ENPOINT_LOGOUT } from '@/services/api'

export function getLocationHrefUrl(extraParams = {}) {
  const domain = getCurrentDomain()
  const whiteList = [domain, 'localhost']
  const mainPage = `https://${domain}`

  // TODO need to handle errors page
  if (
    window.location.pathname.includes('/errors') ||
    !whiteList.includes(window.location.hostname)
  ) {
    return mainPage
  } else {
    const cleanLocationHref = window.location.href.split('?')[0]
    const queryParams = new URLSearchParams()

    Object.entries(extraParams).forEach(([key, value]) => {
      queryParams.append(key, value as string)
    })

    const queryString = queryParams.toString()
    return queryString ? `${cleanLocationHref}?${queryString}` : cleanLocationHref
  }
}

function getReferrerUrl() {
  const domain = getCurrentDomain()
  const mainPage = `https://${domain}`

  if (!document.referrer) {
    // TODO need to handle errors page
    if (window.location.pathname.includes('/errors') || window.location.hostname !== domain) {
      return mainPage
    } else {
      return window.location.href
    }
  }

  const url = new URL(document.referrer)
  // TODO need to handle errors page
  if (url.pathname.includes('/errors') || url.hostname !== domain) {
    return mainPage
  } else {
    return url.origin + url.pathname + url.search
  }
}

export type LoginParams = {
  callback?: string
  loginParams?: Record<string, string>
  vodafoneURLPostfix?: string
}

export async function getLoginUrl({ callback, loginParams, vodafoneURLPostfix }: LoginParams) {
  callback = callback && typeof callback === 'string' ? callback : getLocationHrefUrl(loginParams)

  const locale = applyUnderline(await getUserLocale())
  const domain = getCreateDomain()
  const loginUrl = `https://${domain}${API_ENPOINT_LOGIN}?hl=${locale}`

  if (vodafoneURLPostfix) {
    const postfixArray = vodafoneURLPostfix.split(',')
    const pathname = window.location.pathname
    const isVodafoneEvent = postfixArray.some((postfix) => pathname.includes('/' + postfix))

    if (isVodafoneEvent) {
      return `${loginUrl}&relevance=vodafone&callback=${encodeURIComponent(callback)}`
    }
  }

  return `${loginUrl}&callback=${encodeURIComponent(callback)}`
}

export async function getLogoutUrl() {
  const locale = applyUnderline(await getUserLocale())
  const domain = getCreateDomain()
  return `https://${domain}${API_ENPOINT_LOGOUT}?hl=${locale}&callback=${encodeURIComponent(getReferrerUrl())}#logout`
}

export function getViveCreatorUrl() {
  const viveAvatarDomain = getViveAvatarDomain()
  return `https://${viveAvatarDomain}/avatar/creator?redirect_url=${encodeURIComponent(
    getLocationHrefUrl(),
  )}`
}

// 🥷🏼 use this way to strip locale from the pathname
// 🥷🏼 ex. /user-worlds -> /user-worlds
// 🥷🏼 ex. /en-US/user-worlds -> /user-worlds
// 🥷🏼 ex. /zh-TW/profile -> /profile
// 🥷🏼 ex. /ja-JP/profile/dog?a=1 -> /profile/dog?a=1
export function stripLocale(pathname: string) {
  const localePattern = new RegExp(`^/(${routing.locales.join('|')})(?=/|$)`)
  return pathname.replace(localePattern, '')
}
